import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "bottomSpacing", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Flex, { Box } from 'components/Flex';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PanelHeader = function PanelHeader(_ref) {
  var actions = _ref.actions,
    _ref$bottomSpacing = _ref.bottomSpacing,
    bottomSpacing = _ref$bottomSpacing === void 0 ? 'xxs' : _ref$bottomSpacing,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Flex, _objectSpread(_objectSpread({
    mt: -6,
    mb: bottomSpacing,
    lineHeight: 1
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: true,
      overflow: "hidden",
      children: children
    }), /*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      borderBottom: "thin",
      ml: "xs"
    }), actions && /*#__PURE__*/_jsx(Box, {
      mr: -6,
      pl: "xxs",
      children: actions
    })]
  }));
};
export default PanelHeader;